<template>
    <div class="analytics">

        <v-card elevation="3" class="select-mode pa-5 mx-5 my-3" v-if="this.$store.state.isAnalyticFilterPopup">
            <v-card-title class="pa-1">Аналитика</v-card-title>
        </v-card>

        <v-row style="max-width: 1200px" class="mx-auto">
            <v-col cols="12" :sm="interfaceCardSm" :md="interfaceCardMd" v-if="interfaceCardPoint&&showCouriersOrder">
                <v-card class="info-card mx-auto elevation-6" max-width="240" color="#2196F3" dark @click="goToLink('orders', true)">
                    <v-list-item two-line>
                        <v-list-item-content>
                            <div class="overline">Заказы</div>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-list-item-title class="tooltip-text headline mb-1 align-center" v-bind="attrs" v-on="on"> <v-icon size="large" class="mr-1">mdi-inbox-multiple</v-icon> {{ orders.length }} </v-list-item-title>
                                </template>
                                <span>Все заказы</span>
                            </v-tooltip>
                            <v-list-item-subtitle>за сегодня</v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-avatar size="60" class="mb-1">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <span class="tooltip-text" v-bind="attrs" v-on="on"> <v-icon size="large">mdi-check-bold</v-icon> {{ ordersDelivered.length }} </span>
                                </template>
                                <span>Доставленные заказы</span>
                            </v-tooltip>
                        </v-list-item-avatar>
                    </v-list-item>
                </v-card>
            </v-col>


            <v-col cols="12" :sm="interfaceCardSm" :md="interfaceCardMd" v-if="interfaceCardOperator&&showCouriersOrder">
                <v-card class="info-card mx-auto elevation-6" max-width="240" color="#DC3546" dark @click="goToLink('points', false)">
                    <v-list-item two-line>
                        <v-list-item-content>
                            <div class="overline">Точки</div>
                            <v-list-item-title class="tooltip-text headline mb-1 d-flex align-center">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <div v-bind="attrs" v-on="on"><v-icon size="large">mdi-home-group</v-icon> {{ pointsCount }}</div>
                                    </template>
                                    <span>Всего точек</span>
                                </v-tooltip>
                                <!-- <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <div v-bind="attrs" v-on="on"><v-icon class="mr-1 ml-3" size="large">mdi-account-multiple</v-icon> {{ point_users.length }}</div>
                                    </template>
                                    <span>Всего менеджеров онлайн</span>
                                </v-tooltip> -->
                            </v-list-item-title>
                            <v-list-item-subtitle>сейчас</v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-avatar size="60" class="mb-1">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <span class="tooltip-text" v-bind="attrs" v-on="on"> <v-icon size="large">mdi-check-bold</v-icon> {{ pointsToday.length }} </span>
                                </template>
                                <span>Точек в работе</span>
                            </v-tooltip>
                        </v-list-item-avatar>
                    </v-list-item>
                </v-card>
            </v-col>

            <v-col cols="12" :sm="interfaceCardSm" :md="interfaceCardMd" v-if="interfaceCardPoint&&showCouriersOrder">
                <v-card class="info-card mx-auto elevation-6" max-width="240" color="#4CAF50" dark @click="goToLink('couriers', false)">
                    <v-list-item two-line>
                        <v-list-item-content>
                            <div class="overline">Курьеры</div>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-list-item-title class="tooltip-text headline mb-1 d-flex align-center" v-bind="attrs" v-on="on"> <v-icon size="large" class="mr-1">mdi-car-multiple</v-icon> {{ couriersOnline.length }} </v-list-item-title>
                                </template>
                                <span>Курьеров онлайн</span>
                            </v-tooltip>
                            <v-list-item-subtitle>сейчас</v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-avatar size="60" class="mb-1">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <span class="tooltip-text" v-bind="attrs" v-on="on"> <v-icon size="large">mdi-check-bold</v-icon> {{ couriersToday.length }} </span>
                                </template>
                                <span>{{ userIsPoint ? 'Всего курьеров на точке' : 'Всего курьеров в работе' }}</span>
                            </v-tooltip>
                        </v-list-item-avatar>
                    </v-list-item>
                </v-card>
            </v-col>

            <v-col cols="12" :sm="interfaceCardSm" :md="interfaceCardMd" v-if="interfaceCardPoint&&showCouriersOrder">
                <v-card class="info-card mx-auto elevation-6" max-width="240" color="#FF9800" dark @click="goToLink('couriers', false)">
                    <v-list-item two-line>
                        <v-list-item-content>
                            <div class="overline">{{ interfaceFeeValue }}</div>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-list-item-title class="tooltip-text headline mb-1 d-flex align-center" v-bind="attrs" v-on="on"> <v-icon size="large" class="mr-1">mdi-cash-multiple</v-icon> {{ profitToday }} ₽ </v-list-item-title>
                                </template>
                                <span>{{ interfaceFeeValue }} всего за сегодня</span>
                            </v-tooltip>
                            <v-list-item-subtitle>за сегодня</v-list-item-subtitle>
                        </v-list-item-content>

                        <!-- <v-list-item-avatar size="60" class="mb-1">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <span class="tooltip-text" v-bind="attrs" v-on="on"> {{ profitDiff }} ₽ </span>
                                </template>
                                <span>{{ interfaceFeeValue }} по сравнению с предыдущим днем</span>
                            </v-tooltip>
                        </v-list-item-avatar> -->
                    </v-list-item>
                </v-card>
            </v-col>
            
            <v-col cols="12" :sm="interfaceCardSm" :md="interfaceCardMd" v-if="interfaceCardPoint&&showCouriersOrder">
                <v-card class="info-card mx-auto elevation-6" max-width="240" color="indigo darken-6" dark @click="goToLink('couriers', false)">
                    <v-list-item two-line>
                        <v-list-item-content>
                            <div class="overline">Цена доставки</div>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-list-item-title class="tooltip-text headline mb-1 d-flex align-center" v-bind="attrs" v-on="on"> <v-icon size="large" class="mr-1">mdi-truck-fast</v-icon> {{ interfaceAveragePriceDeliveryMy || 0 }} ₽</v-list-item-title>
                                </template>
                                <span>Средняя цена доставки</span>
                            </v-tooltip>
                            <v-list-item-subtitle v-show="$store.state.user.role != 1">весь сервис: {{ interfaceAveragePriceDeliveryAll || 0 }} ₽</v-list-item-subtitle>
                            <v-list-item-subtitle v-show="$store.state.user.role == 1"><wbr></v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-avatar size="60" class="mb-1">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <span class="tooltip-text" v-bind="attrs" v-on="on"> <v-icon size="large">mdi-check-bold</v-icon> {{ interfaceAveragePriceDeliveryMyCount || 0 }} </span>
                                </template>
                                <span>Доставленные заказы, на основе которых определена средняя цена, шт.</span>
                            </v-tooltip>
                        </v-list-item-avatar>
                    </v-list-item>
                </v-card>
            </v-col>
            <v-col cols="12" :sm="interfaceCardSm" :md="interfaceCardMd" v-if="interfaceCardOperator&&showServicesOrder">
                <v-card class="info-card mx-auto elevation-6" max-width="240" color="#f0c" dark @click="goToLink('services', false)">
                    <v-list-item two-line>
                        <v-list-item-content>
                            <div class="overline">Сервисы</div>
                            <v-list-item-title class="tooltip-text headline mb-1 d-flex align-center">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <div v-bind="attrs" v-on="on"><v-icon size="large">mdi-cogs</v-icon> {{ services.length }}</div>
                                    </template>
                                    <span>Всего сервисов</span>
                                </v-tooltip>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <div v-bind="attrs" v-on="on"><v-icon class="mr-1 ml-3" size="large">mdi-account-cog</v-icon> {{ service_users.length }}</div>
                                    </template>
                                    <span>Всего операторов онлайн</span>
                                </v-tooltip>
                            </v-list-item-title>
                            <v-list-item-subtitle>сейчас</v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-avatar size="60" class="mb-1">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <span class="tooltip-text" v-bind="attrs" v-on="on"> <v-icon size="large">mdi-check-bold</v-icon> {{ servicesTodayCount }} </span>
                                </template>
                                <span>Сервисов в работе</span>
                            </v-tooltip>
                        </v-list-item-avatar>
                    </v-list-item>
                </v-card>
            </v-col>
        </v-row>

        <v-row v-if="loaded&&showCouriersOrder" style="max-width: 1200px" class="mx-auto">
            <v-col cols="12" sm="12" :md="interfaceOverviewMd" :lg="interfaceOverviewLg" v-if="interfaceOverviewPoint">
                <v-card align="center" justify="center" class="overview mx-auto elevation-6">
                    <v-toolbar class="mb-2" height="50" color="cyan darken-1 elevation-3" dark flat>
                        <v-toolbar-title class="overline">Обзор заказов по статусам</v-toolbar-title>
                    </v-toolbar>
                    <Donut class="order-chart" :centerLabel="{ text: getOrdersCountPercent(), title: 'Процент доставленных заказов к общему количеству' }" :chartData="chartDataOrders" :colors="orderStatusColorsHtml()" />
                </v-card>
            </v-col>
            <v-col cols="12" sm="12" :md="interfaceOverviewMd" :lg="interfaceOverviewLg" v-if="interfaceOverviewOperator">
                <v-card align="center" justify="center" class="overview mx-auto elevation-6">
                    <v-toolbar class="mb-2" height="50" color="cyan darken-1 elevation-3" dark flat>
                        <v-toolbar-title class="overline">Обзор заказов по точкам, top-20</v-toolbar-title>
                    </v-toolbar>
                    <Donut class="order-chart" :chartData="chartDataPoints" :colors="colorsHtml" />
                </v-card>
            </v-col>
            <v-col cols="12" sm="12" :md="interfaceOverviewMd" :lg="interfaceOverviewLg" v-if="interfaceOverviewPoint">
                <v-card align="center" justify="center" class="overview mx-auto elevation-6">
                    <v-toolbar class="mb-2" height="50" color="cyan darken-1 elevation-3" dark flat>
                        <v-toolbar-title class="overline">Обзор заказов по курьерам, top-20</v-toolbar-title>
                    </v-toolbar>
                    <Donut class="order-chart" :chartData="chartDataCouriers" :colors="colorsHtml" />
                </v-card>
            </v-col>
        </v-row>

        <v-row v-if="loaded&&showServicesOrder" style="max-width: 1200px" class="mx-auto d-flex justify-center mb-8">
            <v-col cols="12" sm="12" :md="interfaceOverviewMd" :lg="interfaceOverviewLg">
                <v-card align="center" justify="center" class="overview mx-auto elevation-6">
                    <v-toolbar class="mb-2" height="50" color="cyan darken-1 elevation-3" dark flat>
                        <v-toolbar-title class="overline">Обзор услуг по статусам</v-toolbar-title>
                    </v-toolbar>
                    <Donut class="order-chart" :centerLabel="{ text: getServicesCountPercent(), title: 'Процент выполненных услуг к общему кол-ву' }" :chartData="chartDataServiceOrders" :colors="orderStatusColorsHtml(true)" />
                </v-card>
            </v-col>
            <v-col cols="12" sm="12" :md="interfaceOverviewMd" :lg="interfaceOverviewLg" v-if="interfaceOverviewOperator">
                <v-card align="center" justify="center" class="overview mx-auto elevation-6">
                    <v-toolbar class="mb-2" height="50" color="cyan darken-1 elevation-3" dark flat>
                        <v-toolbar-title class="overline">Обзор услуг по точкам, top-20</v-toolbar-title>
                    </v-toolbar>
                    <Donut class="order-chart" :chartData="chartDataServicePoints" :colors="colorsHtml" />
                </v-card>
            </v-col>
            <v-col cols="12" sm="12" :md="interfaceOverviewMd" :lg="interfaceOverviewLg">
                <v-card align="center" justify="center" class="overview mx-auto elevation-6">
                    <v-toolbar class="mb-2" height="50" color="cyan darken-1 elevation-3" dark flat>
                        <v-toolbar-title class="overline">Обзор услуг по сервисменам, top-20</v-toolbar-title>
                    </v-toolbar>
                    <Donut class="order-chart" :chartData="chartDataWorkers" :colors="colorsHtml" />
                </v-card>
            </v-col>
        </v-row>

        <v-row style="max-width: 1800px" class="mx-auto" v-if="showCouriersOrder&&(userIsPoint||userIsOperator)">
            <v-col cols="12">
                <v-card class="mx-auto pb-3 elevation-6">
                    <v-toolbar class="mb-2" height="50" color="indigo darken-6 elevation-3" dark flat>
                        <v-toolbar-title class="overline">Последние 30 заказов</v-toolbar-title>
                    </v-toolbar>
                    <v-simple-table dense>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">Сист.</th>
                                    <th v-if="$store.state.settings.marketingSourceView" class="text-left">Источник</th>
                                    <th class="text-left">Название</th>
                                    <th class="text-left">Статус</th>
                                    <th class="text-left">Гость</th>
                                    <th class="text-left">Адрес доставки</th>
                                    <th v-if="userIsPoint" class="text-left">Цена</th>
                                    <th v-if="!userIsPoint" class="text-left">Цена курьера</th>
                                    <th v-if="!userIsPoint" class="text-left">Цена точки</th>
                                    <th class="text-left">Курьер</th>
                                    <th class="text-left">Готов</th>
                                    <th class="text-left">Забрать</th>
                                    <th class="text-left">Доставить</th>
                                    <th class="text-left">Забран</th>
                                    <th class="text-left">Доставлен</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="item in [...orders].slice(0, 30)" :key="item.id">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <td class="tooltip-text" v-bind="attrs" v-on="on">
                                                <v-avatar size="24">
                                                    <img alt="source" :src="iconSource1(item)" />
                                                </v-avatar>
                                            </td>
                                        </template>
                                        <span>{{ tooltipSource1(item) }}</span>
                                    </v-tooltip>

                                    <tdFade v-if="$store.state.settings.marketingSourceView" :data="item.externalSource ? item.externalSource : ''" />

                                    <tdFade bold :data="getOrderName(item)" />

                                    <td>
                                        <v-chip :color="orderStatusColorHtml1(item.status)" text-color="white">
                                            <v-icon size="small" class="mr-1">{{ orderStatusIcon1(item.status) }}</v-icon>
                                            {{ orderStatusStr1(item.status) }}
                                        </v-chip>
                                    </td>

                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <td class="tooltip-text" v-bind="attrs" v-on="on">
                                                <tdFade :data="item.customerString ? item.customerString.substr(0, 24) : '--'" />
                                            </td>
                                        </template>
                                        <span>{{ item.customerString ?? '--' }}</span>
                                    </v-tooltip>

                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <td class="tooltip-text" v-bind="attrs" v-on="on" :style="!item.latitude ? 'color: red' : ''">
                                                <tdFade :data="item.address ? item.address.substr(0, 24) : '--'" />
                                            </td>
                                        </template>
                                        <span>{{ item.address ?? '--' }}</span>
                                    </v-tooltip>

                                    <td v-if="!userIsPoint" :style="!item.latitude ? 'color: red' : ''">
                                        <tdFade :data="item.feeCourier" />
                                    </td>

                                    <td :style="!item.latitude ? 'color: red' : ''">
                                        <tdFade :data="item.feePoint" />
                                    </td>

                                    <td class="d-flex align-center">
                                        <v-avatar size="24" class="mr-2" v-if="item.courierId">
                                            <img alt="courier" :src="`${config.api.delivery}/v1/courier_avatar?id=${item.courierId}`" />
                                        </v-avatar>
                                        <tdFade v-if="userIsPoint" bold :data="getOrderCourierName(item, item.courier, true).substr(0, 24)" />
                                        <tdFade v-else bold :data="getOrderCourierName(item, item.courier).substr(0, 24)" />
                                    </td>

                                    <tdFade :data="getOrderMode(item, true) + ' ' + timeToString(item.createdAt)" />

                                    <tdFade :data="timeToString(item.dateReady)" />

                                    <tdFade :data="timeToString(item.dateDelivery)" />

                                    <td>
                                        <span class="mr-2">{{ timeToString(item.dateTake) }}</span>
                                        <v-chip v-if="item.dateTake" class="px-1" :color="timeColorHtml(item.dateTake, item.dateReady)" x-small label text-color="white">
                                            {{ timeDiff(item.dateTake, item.dateReady) }}
                                        </v-chip>
                                    </td>

                                    <td>
                                        <span class="mr-2">{{ timeToString(item.dateComplete) }}</span>
                                        <v-chip v-if="item.dateComplete" class="px-1" :color="timeColorHtml(item.dateComplete, item.dateDelivery)" x-small label text-color="white">
                                            {{ timeDiff(item.dateComplete, item.dateDelivery) }}
                                        </v-chip>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <span v-if="!orders.length" class="no-data"> Нет данных </span>
                </v-card>
            </v-col>
        </v-row>

        <v-row style="max-width: 1800px" class="mx-auto" v-if="showServicesOrder&&(userIsService||userIsOperator)">
            <v-col cols="12">
                <v-card class="mx-auto pb-3 elevation-6">
                    <v-toolbar class="mb-2" height="50" color="indigo darken-6 elevation-3" dark flat>
                        <v-toolbar-title class="overline">Последние 30 услуг</v-toolbar-title>
                    </v-toolbar>
                    <v-simple-table dense>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">Сист.</th>
                                   
                                    <th class="text-left">Название</th>
                                    <th class="text-left">Статус</th>
                                    <th class="text-left">Адрес заказа</th>
                                    <th class="text-left">Заказчик</th>
                                    
                                    <th class="text-left">Сервис</th>
                                    <th class="text-left">Сервисмен</th>
                                    <th class="text-left">Цена заказа</th>
                                    <th class="text-left">% Комиссия</th>
                                    <th class="text-left">К выплате сервисмену</th>
                                    <th class="text-left">Время</th>
                                    <th class="text-left">Принят</th>
                                    <th class="text-left">Выполнен</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="item in service_orders.slice(0, 30)" :key="item.id">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <td class="tooltip-text" v-bind="attrs" v-on="on">
                                                <v-avatar size="24">
                                                    <img alt="source" :src="iconSource(item)" />
                                                </v-avatar>
                                            </td>
                                        </template>
                                        <span>{{ tooltipSource(item) }}</span>
                                    </v-tooltip>

                                    <tdFade v-if="$store.state.settings.marketingSourceView" :data="item.options.marketingSource ? item.options.marketingSource : ''" />

                                    <tdFade bold :data="item.name" />

                                    <td>
                                        <v-chip :color="orderStatusColorHtml(item.status)" text-color="white">
                                            <v-icon size="small" class="mr-1">{{ orderStatusIcon(item.status) }}</v-icon>
                                            {{ orderStatusStr(item.status,true) }}
                                        </v-chip>
                                    </td>

                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <td class="tooltip-text" v-bind="attrs" v-on="on">
                                                <tdFade :data="item.finish_addr.substr(0, 24)" />
                                            </td>
                                        </template>
                                        <span>{{ item.finish_addr }}</span>
                                    </v-tooltip>

                                    <tdFade :data="points.length?points.find(p=>p.id==item.point_id).name:''" />
                                    <tdFade :data="item.service_name" />
                                  
                                  

                                    <td class="d-flex align-center">
                                        <v-avatar size="24" class="mr-2" v-if="item.worker_name != '--'">
                                            <img alt="worker" :src="`${config.api.delivery}/v1/user_avatar?tid=${item.worker_tid}`" />
                                        </v-avatar>
                                        <tdFade bold :data="item.worker_name" />
                                    </td>

                                    <tdFade :data="Number(item.pay_cost)" />

                                    <tdFade :data="item.percent+'%'" />

                                    <td><span>
                                        {{item.fee_worker}}
                                    </span></td>

                                    <tdFade :data="timeToString(item.date)" />

                                    <td>
                                        <span class="mr-2">{{ timeToString(item.date_accept) }}</span>
                                        <v-chip v-if="item.date_accept" class="px-1" :color="timeColorHtml(item.date, item.date_accept)" x-small label text-color="white">
                                            {{ timeDiff(item.date, item.date_accept) }}
                                        </v-chip>
                                    </td>

                                    <td>
                                        <span class="mr-2">{{ timeToString(item.date_complete) }}</span>
                                        <v-chip v-if="item.date_complete" class="px-1" :color="timeColorHtml(item.date_accept, item.date_complete)" x-small label text-color="white">
                                            {{ timeDiff(item.date_accept, item.date_complete) }}
                                        </v-chip>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <span v-if="!orders.length" class="no-data"> Нет данных </span>
                </v-card>
            </v-col>
        </v-row>

        <Proceeds v-if="showCouriersOrder&&(userIsPoint||userIsOperator)" />
        <CancelledOrders v-if="userIsService||userIsOperator" />
        <span class="pb-16 d-block" />
    </div>
</template>

<script>
    import config from '../../config'
    import Donut from './Donut.vue'
    import TdFade from './TdFade.vue'
    import Proceeds from './Proceeds.vue'
    import CancelledOrders from './CancelledOrdersRatio.vue'

    import DateTime from '../../mixins/DateTime.js'
    import Status from '../../mixins/Status.js'
    import Orders from '../../mixins/Orders.js'
    import Notify from '../../mixins/Notify.js'

    export default {
        mixins: [DateTime, Status, Orders, Notify],
        data() {
            return {
                config,
                loaded: false,
                chartDataOrders: {},
                chartDataPoints: {},
                chartDataCouriers: {},
                chartDataWorkers: {},
                chartDataServicePoints: {},
                chartDataServiceOrders: {},

                orders: [],
                ordersDelivered: [],
                combined_orders: [],
                service_orders: [],
                workers:[],
                point_users: [],
                services:[],
                service_users:[],
                users: [],
                pointsDonut: [],
                pointsDonutCounts: [],
                pointsToday: [],
                pointsTodayCounts: [],
                couriersOnline: [],
                couriersDonut: [],
                couriersDonutCounts: [],
                couriersToday: [],
                couriersTodayCounts: [],
                couriersSelected: [],
                labelsSelected: [],
                pointsCount: 0,
                profitToday: 0,
                profitYesterday: 0,
                profitDiff: 0,
                serviceProfitToday: 0,
                serviceProfitYesterday: 0,
                serviceProfitDiff: 0,
                interfaceFeeValue: true,
                interfaceCardOperator: true,
                interfaceCardPoint:true,
                interfaceCardService:true,
                interfaceCardMd: 3,
                interfaceCardSm: 6,
                interfaceOverviewOperator: true,
                interfaceOverviewPoint: true,
                interfaceOverviewMd: 6,
                interfaceOverviewLg: 4,
                interfaceAveragePriceDeliveryMy: 0,
                interfaceAveragePriceDeliveryMyCount:0,
                interfaceAveragePriceDeliveryAll: 0,

                orderStatuses: [],
                serviceOrderStatuses:[],
                showCouriersOrder:true,
                showServicesOrder:this.$store.state.settings.services_enable,
                timer: null,
                userIsPoint: false,
                userIsService:false,
                userIsOperator:false,
                loading: false,
                multiOrders: [],
            }
        },
        components: {
            Donut,
            TdFade,
            Proceeds,
            CancelledOrders
        },
        mounted() {
            console.log('!!! mounted !!!')
            // console.log('NOW - ', moment().format('YYYY-MM-DD'))

            this.userIsOperator = this.$store.state.user.role == config.user.role.operator
            this.userIsPoint = this.$store.state.user.role !== config.user.role.operator
            this.userIsService = this.$store.state.user.role == config.user.role.service

        
            if (this.$store.state.user.role == config.user.role.operator) {
                // this.interfaceFeeValue = 'Выручка'
                this.interfaceFeeValue = 'Зарплата'

                this.interfaceCardOperator = true
                this.interfaceCardMd = 4
                this.interfaceCardSm = 6

                this.interfaceOverviewOperator = true
                this.interfaceOverviewMd = 6
                this.interfaceOverviewLg = 4
            } else if(this.$store.state.user.role !== config.user.role.operator){
                this.interfaceFeeValue = 'Расходы'
                // this.interfaceFeeValue = 'Зарплата'

                this.interfaceCardOperator = false
                this.interfaceCardService = false
                this.interfaceCardMd = 6
                this.interfaceCardSm = 6
                this.interfaceOverviewOperator = false
                this.interfaceOverviewMd = 12
                this.interfaceOverviewLg = 6
            } else if(this.$store.state.user.role == config.user.role.service){

                this.showServicesOrder = true
                this.interfaceCardOperator = false
                this.interfaceCardPoint = false
                this.interfaceOverviewPoint = false
                this.interfaceCardMd = 4
                this.interfaceCardSm = 6

                this.interfaceOverviewOperator = false
                this.interfaceOverviewMd = 6
                this.interfaceOverviewLg = 4
            }

            this.updateData()
            this.timer = setInterval(() => {
                this.updateData()
            }, 5000)
            this.getAveragePriceDelivery()
        },

        beforeDestroy() {
            console.log('!!! beforeDestroy !!!')
            if (this.chart) {
                this.chart.dispose()
            }
        },

        destroyed() {
            console.log('!!! destroyed !!!')
            return this.timer ? clearInterval(this.timer) : false
        },
        watch: {},
        computed: {},
        methods: {
            getAveragePriceDelivery(){
                let how = ""
                let id = 0
                this.role = this.$store.state.user.role

                switch (this.role) {
                    case 1: //operator
                        how = "operator"
                        id = this.$store.state.user.tid || 0
                        break
                    case 3: //point
                        how = "point"
                        id = this.$store.state.user.point_id || 0
                        break
                    default:
                        break
                }

                // this.$store
                //         .dispatch('get_average_price_delivery', {
                //             how: how, //
                //             id: id,
                //         })
                //         .then(res => {
                //             if (res.data) {
                //                 this.interfaceAveragePriceDeliveryMy = res.data.my
                //                 this.interfaceAveragePriceDeliveryMyCount = res.data.my_count
                //                 this.interfaceAveragePriceDeliveryAll = res.data.all
                //             }
                //             })
            },
            onClickGuest(order) {
                if (order.guest_id) {
                    const name = order.guest_name ? order.guest_name + ' ' : ''
                    this.notifyToast('Гость: ' + name + order.guest_phone, { color: 'info', timeout: 4000 })
                    this.$router.push({ name: 'guests_phone', params: { phone: order.guest_phone } })
                    // this.$router.push({ name: 'guests_phone', params: {phone: order.guest_phone} })
                }
            },
            goToLink(name, all_users) {
                if (!this.userIsPoint || all_users) {
                    this.$router.push({ name })
                }
            },
            getOrdersCountPercent() {
                return this.orders.length > 0 ? Math.round((this.ordersDelivered.length / this.orders.length) * 100) + '%' : ''
            },
            getTdCatted(str) {
                return '<td>Hello</td>'
            },
            pointsLabels() {
                const res = []
                this.pointsDonut.forEach((point, i) => {
                    res[i] = point.name.substr(0, 20)
                })
                return res
            },
            couriersLabels() {
                const res = [[], []]
                this.couriersDonut.forEach((courier, i) => {
                    res[0][i] = this.getCourierName(courier, this.userIsPoint).substr(0, 20)
                    res[1][i] = !courier.user?.chatBotAccount?.isLogged
                })
                return res
            },
            orderStatusLabels(service = false) {
                const res = [[], []]
                let len = service ? 8 : 6
                let index = 0;
                for (let i = 0; i < len; i++) {
                    if (service) {
                        if (i == 6) continue
                        else res[i] = this.orderStatusStr(i, service)
                        index++;
                    } else {
                        if (i == 6) break
                        res[i] = this.orderStatusStr(i)
                    } 
                }
                return res
            },
            orderStatusColorsHtml() {
                return [
                    this.orderStatusColorHtml(0),
                    this.orderStatusColorHtml(1),
                    this.orderStatusColorHtml(2),
                    this.orderStatusColorHtml(3),
                    this.orderStatusColorHtml(4),
                    this.orderStatusColorHtml(5),
                ]
            },

            fillDataOrders() {
                this.interfaceAveragePriceDeliveryMy = 0
                this.interfaceAveragePriceDeliveryMyCount = 0
                this.interfaceAveragePriceDeliveryAll = 0
                // this.interfaceAveragePriceDeliveryMy = res.data.my
                // this.interfaceAveragePriceDeliveryMyCount = res.data.my_count
                // this.interfaceAveragePriceDeliveryAll = res.data.all

                this.profitToday = 0
                this.profitYesterday = 0
                // this.profitToday = res.data.profitToday
                // this.profitYesterday = res.data.profitYesterday

                this.ordersDelivered = this.orders.filter(order => order.status == this.OrderStatus.delivered)

                this.orderStatuses[0] = 0
                this.orderStatuses[1] = 0
                this.orderStatuses[2] = 0
                this.orderStatuses[3] = 0
                this.orderStatuses[4] = 0
                this.orderStatuses[5] = 0

                const pointsTodaySet = new Set()
                const couriersTodaySet = new Set()

                this.pointsToday = []
                this.couriersToday = []

                for (let i = 0; i < this.orders.length; i += 1) {
                    const order = this.orders[i]

                    if (!pointsTodaySet.has(order.pointId)) {
                        pointsTodaySet.add(order.pointId)
                        this.pointsToday.push(order.point)
                    }
                    
                    if (order.courierId != null && !couriersTodaySet.has(order.courierId)) {
                        couriersTodaySet.add(order.courierId)
                        this.couriersToday.push(order.courier)
                    }
                }

                this.couriersOnline = this.couriersToday.filter(courier => courier.user?.chatBotAccount?.isLogged)

                this.pointsToday.forEach((point, i) => {
                    this.pointsTodayCounts[i] = 0
                })
                this.couriersToday.forEach((courier, i) => {
                    this.couriersTodayCounts[i] = 0
                })

                this.orders.forEach(order => {
                    this.orderStatuses[this.orderStatusToIndex(order)] += 1

                    if (order.status === this.OrderStatus.delivered) {
                        this.profitToday += this.userIsPoint ? order.feePoint : order.feeCourier
                    }

                    this.pointsToday.forEach((point, i) => {
                        if (point.id == order.pointId) {
                            this.pointsTodayCounts[i] += 1
                        }
                    })

                    this.couriersToday.forEach((courier, i) => {
                        if (courier.id == order.courier?.id) {
                            this.couriersTodayCounts[i] += 1
                        }
                    })
                })

                let mapped = this.pointsTodayCounts.map((el, i) => {
                    return { index: i, value: el }
                })
                mapped.sort((a, b) => b.value - a.value)
                mapped = mapped.slice(0, 20)
                this.pointsDonut = mapped.map(el => this.pointsToday[el.index])
                this.pointsDonutCounts = mapped.map(el => this.pointsTodayCounts[el.index])

                mapped = this.couriersTodayCounts.map((el, i) => {
                    return { index: i, value: el }
                })
                mapped.sort((a, b) => b.value - a.value)
                mapped = mapped.slice(0, 20)
                this.couriersDonut = mapped.map(el => this.couriersToday[el.index])
                this.couriersDonutCounts = mapped.map(el => this.couriersTodayCounts[el.index])

                this.profitDiff = this.profitYesterday - this.profitToday

                this.chartDataOrders = {
                    labels: this.orderStatusLabels(),
                    disabled: [],
                    hidden:[],
                    datasets: [
                        {
                            backgroundColor: this.orderStatusColorsHtml(),
                            data: this.orderStatuses,
                        },
                    ],
                }
            },

            fillDataPoints() {
                this.chartDataPoints = {
                    labels: this.pointsLabels(),
                    disabled: [],
                    hidden:[],
                    datasets: [
                        {
                            backgroundColor: this.colorsHtml,
                            data: this.pointsDonutCounts,
                        },
                    ],
                }
            },

            fillDataCouriers() {
                const labels = this.couriersLabels()
                this.chartDataCouriers = {
                    labels: labels[0],
                    disabled: labels[1],
                    hidden:[],
                    datasets: [
                        {
                            backgroundColor: this.colorsHtml,
                            data: this.couriersDonutCounts,
                        },
                    ],
                }
            },

            updateData() {
                this.$store
                    .dispatch('analytics_get', {
                        pointId: this.userIsPoint ? this.$store.state.user.pointId : undefined,
                    })
                    .then(res => {
                        if (res.data.success) {
                            this.pointsCount =  res.data.pointsCount
                            this.orders = res.data.orders.reverse()

                            this.fillDataOrders()
                            if (!this.userIsPoint) {
                                this.fillDataPoints()
                            }
                            this.fillDataCouriers()
                            this.loaded = true
                        }
                    })
                    .catch(err => {
                        console.error(err)
                    })
            },
        },

    }
</script>

<style lang="stylus" scoped>
    .analytics
        height 100%
        padding-top 10px !important
        .overview
            max-width 400px
        .text
            padding 0
        .v-card
            cursor default
        .v-toolbar
            border-bottom-left-radius 0 !important
            border-bottom-right-radius 0 !important

        .v-data-table
            padding 0 16px
            .v-data-table__wrapper > table > thead > tr
                th
                    white-space nowrap
                    padding 0 8px

            .v-data-table__wrapper > table > tbody > tr
                td      
                    white-space nowrap
                    cursor default
                    .text
                        padding 0 8px

                    padding 0 8px
                    font-size 0.75rem
                    p
                        margin-top 6px
                        margin-bottom 6px
                        height 22px
                    td.tooltip-text
                        padding-left 0
                    td
                        padding-left 0

        .v-tooltip__content
            background #222
            color #fff
            border-radius 6px
            padding 5px 10px 4px

        .v-chip
            &.v-size--default
                font-size 0.75rem
                height 20px
                border-radius 16px
                margin 4px
                cursor default
                padding 0 6px

        .v-chip.v-size--x-small
            height 18px

        b
            font-weight 500

        .info-card
            cursor pointer

        .v-list-item__content
            padding 8px 0
            overflow initial

        .no-data
            width 100%
            display block
            text-align center
            color #999
            font-size 13px
            height 30px
            line-height 30px

        .guest-error
            color #F44336

        .guest-selectable
            font-weight 400
            color #0D47A1
            cursor pointer
            &:hover
                text-decoration: underline

        .select-mode
            position:fixed
            z-index :10
            
            @media (max-width:1700px)
                position:static
        
</style>
